<ion-card>
  <ion-card-content>
    <ion-fab vertical="center" horizontal="end">
        <ion-row class="ion-no-margin ion-no-padding">
            <ion-col class="ion-no-margin ion-no-padding">
                <ion-fab-button (click)="addRepairItem()" size="small" color="light">
                    <ion-icon name="add-outline"></ion-icon>
                </ion-fab-button>
            </ion-col>
        </ion-row>
    </ion-fab>
    <ion-label >Repair Items</ion-label>

  </ion-card-content>
  <ion-item-sliding *ngFor="let item of document.serviceJob.customerRepairItems;index as i">
      <ion-item>
         <ion-card style="background-color: darkcyan;" >
            <select-plant [document]="document" [addAccessories]="true" [customerRepair]="true" [customerRepairItem]="item" [indx]="i"></select-plant>
            <bundle-items [document]="document" [customerRepairItem]="item"></bundle-items>
         </ion-card>
      </ion-item>
     
      <ion-item-options side="end">
        <ion-item-option color="none" class="ion-float-right">
            <ion-button color="danger" (click)="removeCustomerRepairItem(i)">
                <ion-icon name="trash" slot="icon-only"></ion-icon>
            </ion-button>
        </ion-item-option>
      </ion-item-options>
  </ion-item-sliding>

</ion-card>
